export default __webpack_public_path__ + "static/media/015.079ef6e5.jpg";